(function () {
  var pre = document.getElementById('lc-preloader');
  if (!pre) return;

  var seen = sessionStorage.getItem('lc-preloader-seen');

  if (!seen) {
    // Erstes Laden: volle Sequenz, danach sofort weg
    var IDS  = ['lc-m1', 'lc-lg'];
    var HOLD = 800;
    var FADE = 500;
    var CYCLE = IDS.length * (HOLD + FADE);

    function show(id) {
      IDS.forEach(function (i) {
        document.getElementById(i).classList.remove('is-visible');
      });
      if (id) document.getElementById(id).classList.add('is-visible');
    }

    IDS.forEach(function (id, i) {
      setTimeout(function () {
        show(id);
      }, i * (HOLD + FADE));
    });

    setTimeout(function () {
      show(null);
      sessionStorage.setItem('lc-preloader-seen', '1');
      setTimeout(function () { pre.classList.add('is-hidden'); }, 500);
    }, CYCLE);

  } else {
    // Jeder weitere Seitenwechsel: nur Logo
    var m1 = document.getElementById('lc-lg');
    if (!m1) return;

    setTimeout(function () { m1.classList.add('is-visible'); }, 50);

    setTimeout(function () {
      m1.classList.remove('is-visible');
      setTimeout(function () { pre.classList.add('is-hidden'); }, 400);
    }, 800);
  }

})();